"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("react");
function t() {
  return (t = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function n(e, t) {
  try {
    var n = e();
  } catch (e) {
    return t(e);
  }
  return n && n.then ? n.then(void 0, t) : n;
}
"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));
var r = function r(e, t) {
  var n = e.getAuthResponse();
  if (e.tokenObj = n, e.tokenId = n.id_token, e.accessToken = n.access_token, e.expiresAt = n.expires_at, t) {
    var r = e.getBasicProfile();
    e.googleId = r.getId(), e.profileObj = {
      googleId: r.getId(),
      imageUrl: r.getImageUrl(),
      email: r.getEmail(),
      name: r.getName(),
      givenName: r.getGivenName(),
      familyName: r.getFamilyName()
    };
  }
};
exports.useGoogleLogin = function (i) {
  var o = i.clientId,
    s = i.hostedDomain,
    c = i.redirectUri,
    a = i.scope,
    u = void 0 === a ? "profile email openid" : a,
    l = i.cookiePolicy,
    d = void 0 === l ? "single_host_origin" : l,
    g = i.fetchBasicProfile,
    f = void 0 === g || g,
    v = i.uxMode,
    p = void 0 === v ? "popup" : v,
    m = i.persist,
    h = void 0 === m || m;
  if (!o) throw new Error("clientId is required.");
  var y,
    I,
    _ = e.useState({
      googleUser: void 0,
      auth2: void 0,
      isSignedIn: !1,
      isInitialized: !1
    }),
    b = _[0],
    k = _[1],
    w = e.useRef(void 0),
    O = e.useRef(void 0),
    P = function P() {
      try {
        var e = window.gapi.auth2.getAuthInstance();
        return e ? Promise.resolve(e.signOut()).then(function () {
          return e.disconnect(), !0;
        }) : Promise.resolve(!1);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    S = function S(e) {
      var n,
        i,
        o,
        s,
        c = e.isSignedIn(),
        a = window.gapi.auth2.getAuthInstance();
      c && !e.tokenId && r(e, f), k({
        auth2: a,
        googleUser: c ? t({}, e, {
          accessToken: null !== (n = w.current) && void 0 !== n ? n : e.accessToken,
          expiresAt: null !== (i = O.current) && void 0 !== i ? i : e.expiresAt,
          tokenObj: t({}, e.tokenObj, {
            access_token: null !== (o = w.current) && void 0 !== o ? o : e.tokenObj.access_token,
            expires_at: null !== (s = O.current) && void 0 !== s ? s : e.tokenObj.expires_at
          })
        }) : void 0,
        isSignedIn: c,
        isInitialized: !0
      });
    };
  return y = "___GOOGLE_LOGIN___", I = function I() {
    var e = {
      client_id: o,
      cookie_policy: d,
      hosted_domain: s,
      fetch_basic_profile: f,
      ux_mode: p,
      redirect_uri: c,
      scope: u
    };
    window.gapi.load("auth2", function () {
      window.gapi.auth2.init(e).then(function (e) {
        var t = e.currentUser.get(),
          n = t.isSignedIn();
        e.currentUser.listen(S), h ? (n && r(t, f), k({
          googleUser: t,
          auth2: e,
          isSignedIn: n,
          isInitialized: !0
        })) : P();
      });
    });
  }, e.useEffect(function () {
    var e = Boolean(document.getElementById(y));
    if (!e) {
      var t = document.createElement("script");
      t.src = "https://apis.google.com/js/api.js", t.id = y, document.body.appendChild(t), I && (t.onload = I), e && I && I();
    }
  }, []), t({}, b, {
    signIn: function signIn(e) {
      try {
        var t = window.gapi.auth2.getAuthInstance();
        return Promise.resolve(n(function () {
          return Promise.resolve(t.signIn(e)).then(function (e) {
            return r(e, f), e;
          });
        }, function (e) {}));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    signOut: P,
    grantOfflineAccess: function grantOfflineAccess(e) {
      try {
        var t = window.gapi.auth2.getAuthInstance();
        return Promise.resolve(n(function () {
          return Promise.resolve(t.grantOfflineAccess(e)).then(function (e) {
            return e.code;
          });
        }, function (e) {}));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    refreshUser: function refreshUser() {
      try {
        return Promise.resolve(n(function () {
          var e = window.gapi.auth2.getAuthInstance().currentUser.get();
          return Promise.resolve(null == e ? void 0 : e.reloadAuthResponse()).then(function (e) {
            if (e) return w.current = e.access_token, O.current = e.expires_at, {
              accessToken: e.access_token,
              expiresAt: e.expires_at
            };
          });
        }, function (e) {}));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  });
};